import { ZjProAbortAddShift } from './types/ZjProAbortAddShift';
import { ZjProCompleteAddShift } from './types/ZjProCompleteAddShift';
import { ZjProElementTapped } from './types/ZjProElementTapped';
import { ZjProInitAddShift } from './types/ZjProInitAddShift';
import { ZjProInitLogin } from './types/ZjProInitLogin';
import { ZjProScreenViewed } from './types/ZjProScreenViewed';
import { track } from './analytics';

export const sendElementTapped = (props: ZjProElementTapped['properties']) =>
  void track('zj_pro_element_tapped', props);

export const sendScreenViewed = (props: ZjProScreenViewed['properties']) =>
  void track('zj_pro_screen_viewed', props);

export const sendInitAddShift = (props: ZjProInitAddShift['properties']) =>
  void track('zj_pro_init_add_shift', props);

export const sendCompleteShift = (props: ZjProCompleteAddShift['properties']) =>
  void track('zj_pro_complete_add_shift', props);

export const sendAbortCompleteShift = (
  props: ZjProAbortAddShift['properties']
) => void track('zj_pro_abort_add_shift', props);

export const sendInitLogin = (props: ZjProInitLogin['properties']) =>
  void track('zj_pro_init_login', props);
